declare global {
    interface Window {
        hj?: (command: string, eventName: string) => void;
    }
}

const HOTJAR_TRIGGER_ATTRIBUTE = 'data-trigger-hotjar-event';

export default class HotjarEventService {
    static #instance: HotjarEventService | null = null;

    #initialized = false;

    public static getInstance(): HotjarEventService {
        if (this.#instance === null) {
            this.#instance = new HotjarEventService();
        }

        return this.#instance;
    }

    public static destroyInstance(): void {
        this.#instance = null;
    }

    public init(): void {
        if (this.#initialized) {
            return;
        }

        this.#initialized = true;
        this.#bindElements();
    }

    #bindElements(): void {
        const elements = document.querySelectorAll<HTMLElement>(`[${HOTJAR_TRIGGER_ATTRIBUTE}]`);

        for (const element of elements) {
            const eventName = element.getAttribute(HOTJAR_TRIGGER_ATTRIBUTE);

            if (!eventName || eventName.trim() === '') {
                continue;
            }

            element.removeAttribute('hidden');
            element.addEventListener('click', () => this.#dispatchEvent(eventName.trim()));
        }
    }

    #dispatchEvent(eventName: string): void {
        if (typeof window.hj !== 'function') {
            return;
        }

        window.hj('event', eventName);
    }
}
